import {createContext, useContext, type Provider} from 'react';

export function createMandatoryContext<ContextType>() : readonly [
  () => ContextType,
  Provider<ContextType | undefined>,
] {
  const Context = createContext<ContextType | undefined>(undefined);

  function useMandatoryContext() {
    const context = useContext(Context);
    if (!context) throw new Error('useMandatoryContext must be inside a Provider with a value');
    return context;
  }

  return [useMandatoryContext, Context.Provider] as const;
}
